export default function customerResults () {
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('.customer-results__card').forEach((card) => {
    const button = card.querySelector('.customer-results__toggle');
    const front = card.querySelector('.customer-results__face--front');
    const back = card.querySelector('.customer-results__face--back');

    const flip = (flipped) => {
      card.classList.toggle('customer-results__card--flipped', flipped);
      button.setAttribute('aria-pressed', String(flipped));
      front.setAttribute('aria-hidden', String(flipped));
      back.setAttribute('aria-hidden', String(!flipped));
    };

    card.classList.add('customer-results__card--interactive');
    button.hidden = false;
    flip(false);

    card.addEventListener('pointerenter', (event) => {
      if (hover.matches && event.pointerType !== 'touch') flip(true);
    });
    card.addEventListener('pointerleave', (event) => {
      if (hover.matches && event.pointerType !== 'touch') flip(false);
    });
    button.addEventListener('click', () => {
      flip(button.getAttribute('aria-pressed') !== 'true');
    });
    button.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') flip(false);
    });
    button.addEventListener('blur', () => flip(false));
  });
}
